import React, { useMemo } from "react";
import { Helmet } from "react-helmet-async";

const SITE_URL = "https://g-factory.kz";

const PostMetaHead = ({ post }) => {
  const slug = post?.slug;
  const title = post?.title?.trim() || "";
  const created_at = post?.created_at;
  const updated_at = post?.updated_at;
  const metadata = post?.metadata || {};

  const canonicalUrl = slug
    ? `${SITE_URL}/blog/${slug}`
    : SITE_URL;

  const postImageUrl = slug
    ? post?.seoImage || `${SITE_URL}/media/${slug}.avif`
    : `${SITE_URL}/logo.svg`;

  const postDesc =
    metadata["post-seo-description"] ||
    "Официальный блог G-Factory — оригинальные часы с гарантией.";

  const datePublished = created_at
    ? new Date(created_at).toISOString()
    : undefined;

  const dateModified = updated_at
    ? new Date(updated_at).toISOString()
    : datePublished;

  const jsonLd = useMemo(() => {
    if (!slug) return null;

    return {
      "@context": "https://schema.org",
      "@type": "BlogPosting",
      mainEntityOfPage: {
        "@type": "WebPage",
        "@id": canonicalUrl,
      },
      headline: title,
      description: postDesc,
      image: [postImageUrl],
      datePublished,
      dateModified,
      inLanguage: "ru-KZ",
      author: {
        "@type": "Organization",
        name: "G-Factory",
        url: SITE_URL,
      },
      publisher: {
        "@type": "Organization",
        name: "G-Factory",
        logo: {
          "@type": "ImageObject",
          url: `${SITE_URL}/logo.svg`,
        },
      },
    };
  }, [slug, canonicalUrl, title, postDesc, postImageUrl, datePublished, dateModified]);

  if (!post || !slug) return null;

  return (
    <Helmet>
      <title>{title}</title>
      <meta name="description" content={postDesc} />
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph */}
      <meta property="og:type" content="article" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={postDesc} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:image" content={postImageUrl} />
      <meta property="og:site_name" content="G-Factory" />
      <meta property="og:locale" content="ru_KZ" />

      {datePublished && (
        <meta property="article:published_time" content={datePublished} />
      )}

      {dateModified && (
        <meta property="article:modified_time" content={dateModified} />
      )}

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={postDesc} />
      <meta name="twitter:image" content={postImageUrl} />

      {/* JSON-LD */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
};

export default PostMetaHead;
